export enum ActionType {
    RI_HOMEPAGE_OBJECTS_GET_PENDING = 'ri_homepage_objects_get_pending',
    RI_HOMEPAGE_OBJECTS_GET_SUCCESS = 'ri_homepage_objects_get_success',
    RI_HOMEPAGE_DETAIL_ENTRY_GET_PENDING = 'ri_homepage_detail_entry_get_pending',
    RI_HOMEPAGE_DETAIL_ENTRY_GET_SUCCESS = 'ri_homepage_detail_entry_get_success',
    RI_HOMEPAGE_REQUEST_SUCCESS = 'ri_homepage_request_success',
    RI_HOMEPAGE_VALUATION_REQUEST_SUCCESS = 'ri_homepage_valuation_request_success',
}
